import { DOCUMENT, isPlatformBrowser, Location } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { NavigationError, Router } from '@angular/router';

const FAILED_CHUNK_MESSAGES = [
  'Failed to fetch dynamically imported module', // Chromium
  'Importing a module script failed', // Safari, WKWebView
  'error loading dynamically imported module', // Firefox
];

function isFailedChunkLoad(error: unknown): boolean {
  return (
    error instanceof Error &&
    FAILED_CHUNK_MESSAGES.some((message) => error.message.includes(message))
  );
}

// A deploy removes the previous build's chunks, so a page not opened yet can
// no longer load in place. Skipped on the first navigation, where reloading
// would loop if the chunk keeps failing.
export function reloadOnFailedChunk({ error, url }: NavigationError): void {
  if (
    !isPlatformBrowser(inject(PLATFORM_ID)) ||
    !inject(Router).navigated ||
    !isFailedChunkLoad(error)
  ) {
    return;
  }
  inject(DOCUMENT).location.assign(inject(Location).prepareExternalUrl(url));
}
